import React, { useState, ChangeEvent, FormEvent } from 'react';
import PageSection from '../components/layout/PageSection';
import FormInput from '../components/forms/FormInput';
import { Mail, Phone, MapPin, Facebook, Twitter } from 'lucide-react';
import Navbar from '../components/Navbar';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      const res = await fetch('http://localhost:8081/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (res.ok) {
        alert('Message envoyé avec succès !');
        setFormData({ name: '', email: '', message: '' }); // reset form
      } else {
        alert('Erreur lors de l\'envoi du message');
      }
    } catch (error) {
      alert('Erreur réseau');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-100 via-white to-green-100">
      <Navbar />
      <PageSection
        title={<span className="text-3xl font-extrabold text-green-700 tracking-tight drop-shadow">Contactez-nous</span>}
        subtitle={<span className="text-lg text-black">Notre équipe est à votre écoute</span>}
      >
        <div className="max-w-3xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="flex items-center p-4 bg-white/90 rounded-2xl shadow border-2 border-green-100">
              <Mail className="w-6 h-6 text-green-500 mr-3" />
              <div>
                <h4 className="font-semibold text-green-700">Email</h4>
                <p className="text-gray-600">contact@gosecunet.com</p>
              </div>
            </div>
            <div className="flex items-center p-4 bg-white/90 rounded-2xl shadow border-2 border-green-100">
              <Phone className="w-6 h-6 text-green-500 mr-3" />
              <div>
                <h4 className="font-semibold text-green-700">Téléphone</h4>
                <p className="text-gray-600">20 23 23 03</p>
              </div>
            </div>
            <div className="flex items-center p-4 bg-white/90 rounded-2xl shadow border-2 border-green-100">
              <MapPin className="w-6 h-6 text-green-500 mr-3" />
              <div>
                <h4 className="font-semibold text-green-700">Adresse</h4>
                <p className="text-gray-600">NouaKchott, Mauritanie</p>
              </div>
            </div>
          </div>

          <div className="flex justify-center space-x-4 mb-8">
            <a href="https://facebook.com/gosecunet" className="text-green-600 hover:text-red-400 transition">
              <Facebook className="w-6 h-6" />
            </a>
            <a href="https://twitter.com/gosecunet" className="text-green-600 hover:text-red-400 transition">
              <Twitter className="w-6 h-6" />
            </a>
          </div>

          <form className="space-y-6 bg-white/90 p-10 rounded-3xl shadow-2xl border-2 border-red-200" onSubmit={handleSubmit}>
            <FormInput
              label={<span className="text-black font-semibold">Nom complet</span>}
              type="text"
              name="name"
              required
              placeholder="Votre nom"
              value={formData.name}
              onChange={handleChange}
              className="text-green-700 bg-white placeholder-gray-400 border-green-200 focus:border-green-400 focus:ring-2 focus:ring-green-100"
            />
            <FormInput
              label={<span className="text-black font-semibold">Email</span>}
              type="email"
              name="email"
              required
              placeholder="votre@email.com"
              value={formData.email}
              onChange={handleChange}
              className="text-green-700 bg-white placeholder-gray-400 border-green-200 focus:border-green-400 focus:ring-2 focus:ring-green-100"
            />
            <FormInput
              label={<span className="text-black font-semibold">Message</span>}
              name="message"
              required
              placeholder="Comment pouvons-nous vous aider ?"
              textarea
              value={formData.message}
              onChange={handleChange}
              className="text-green-700 bg-white placeholder-gray-400 border-green-200 focus:border-green-400 focus:ring-2 focus:ring-green-100"
            />
            <button
              type="submit"
              className="w-full bg-gradient-to-r from-green-400 via-green-500 to-red-400 text-white font-bold py-3 rounded-xl shadow-md hover:scale-105 hover:shadow-lg transition-all duration-200 text-lg mt-2"
            >
              Envoyer le message
            </button>
          </form>
        </div>
      </PageSection>
    </div>
  );
};

export default Contact;
